import { useState } from "react";
import axios from "axios";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import PageTitle from "../PageTitle/PageTitle";
import "./Contact.css";
import ContactSvg from "./Contact.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    contactNumber: "", // Updated to match the backend field name
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://sisjamudag.in/contact/message",
        formData
      );
      toast.success(response.data.message || "Message submitted successfully!");
      setFormData({
        name: "",
        contactNumber: "",
        email: "",
        message: "",
      });
    } catch (error) {
      toast.error(error.response.data || "Failed to submit the message.");
    }
  };

  return (
    <div
      style={{
        height: "100%",
        margin: "0",
        padding: "0",
        backgroundImage:
          "linear-gradient(90.1deg, rgba(8, 81, 98, 1) 14.5%, rgb(243, 198, 249) 135.4%)",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Navbar />
      <PageTitle
        svg={ContactSvg}
        p2={
          <>
            Email:{" "}
            <span className="text-white mx-1">
              <a
                href="mailto:shineinternationalschool09@gmail.com"
                style={{
                  textDecoration: "none",
                  color: "white",
                }}
              >
                <strong>
                  <u>shineinternationalschool09@gmail.com</u>
                </strong>
              </a>
            </span>
          </>
        }
        p3={
          <>
            Address: Near Gramin Bank, Jamudag, <br /> Sonahatu, Ranchi, Pin -
            835204
          </>
        }
      />
      <div className="container text-white bg-secondary bg-gradient rounded my-5 p-5">
        <h3 className="text-center my-3">Submit this form for any query</h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              id="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Contact Number</label>
            <input
              type="number" // Use type="text" to avoid issues with large numbers
              className="form-control"
              id="contactNumber" // Updated to match the backend field name
              value={formData.contactNumber}
              onChange={handleChange}
              maxLength={10}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              id="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Type Your Message</label>
            <textarea
              className="form-control"
              id="message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <div className="d-grid gap-2 mt-5">
            <button className="btn btn-success" type="submit">
              Submit
            </button>
          </div>
        </form>
      </div>
      <div className="container herosec rounded p-2 mt-4">
        <iframe
          className="imap rounded"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12000.04793037!2d85.738205!3d23.230757000000004!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f5ad8ad5b2722b%3A0x554077f8ff5b5d44!2sShine%20International%20School!5e0!3m2!1sen!2sin!4v1734819379260!5m2!1sen!2sin"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <Footer />
      <ToastContainer />
    </div>
  );
};

export default Contact;
